export default __webpack_public_path__ + "static/media/arrow-right-icon.3b8cca98.svg";